import * as React from 'react'
import Scrollchor from 'react-scrollchor'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/menu.css'
import styles from './styles.module.scss'
import { categories } from '../../global/categories'
import { textToClassName } from '../../global/textToClassName'

interface Props {
  activeCategory: string
}

const categoryKeys = Object.keys(categories)

function trackClicksOnCategoryMenu(categoryClicked: string) {
  window.dataLayer = window.dataLayer || []
  window.dataLayer.push({
    event: 'Interactions',
    // eslint-disable-next-line @typescript-eslint/camelcase
    event_action: 'click',
    // eslint-disable-next-line @typescript-eslint/camelcase
    event_label: `categoryMenu:${categoryClicked}`
  })
}

export function CategoryMenu({ activeCategory }: Props) {
  return (
    <div className={`category-menu ${styles.categoryMenu}`}>
      <div className={`ui attached inverted menu`}>
        <div className='ui container'>
          {categoryKeys.map(category => {
            const cleanedCategory = textToClassName(category)
            return (
              <Scrollchor
                afterAnimate={() => {
                  trackClicksOnCategoryMenu(category)
                }}
                key={`cat-${cleanedCategory}`}
                to={`#cat-${cleanedCategory}`}
                animate={{ offset: -47 }}
                className={`${
                  activeCategory === `cat-${cleanedCategory}` ? 'active' : ''
                } item ${styles.item}`}
                style={{
                  backgroundColor:
                    activeCategory === `cat-${cleanedCategory}`
                      ? categories[category][1]
                      : 'transparent'
                }}
              >
                {category}
              </Scrollchor>
            )
          })}
        </div>
      </div>
    </div>
  )
}
